// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2KvYh","list":"PatternAutocomplete_list__2Krpn"};